import { KEY_MAP } from './types'

export const findKeyEvent = (event: KeyboardEvent) => {
  const eventKey = event.key
  const eventKeyCode = event.keyCode
  const keyWhich = event.which

  for (const [key, value] of Object.entries(KEY_MAP)) {
    if (value.codes.includes(eventKeyCode) || value.codes.includes(keyWhich)) {
      return key
    } else if (value.keys.includes(eventKey)) {
      return key
    }
  }
  return null
}
